//import NavOption from "../NavOption";
import React, { useContext } from "react";
import chevron from "../../../../assets/chevron.svg";
import styles from "./NavMenu.module.css";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../context/AuthContext";
import NavbarOptionTheme from "../NavbarOptionTheme";

const WorkTypeMenu = ({ ACTIONS, dispatch, state, closeMenus }) => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutHandler = () => {
    authCtx.logout();
    navigate("/", {
      replace: true,
    });
  };

  const requestCrewHandler = () => {
    window.open(
      "https://forms.office.com/Pages/ResponsePage.aspx?id=mQdSd32aE0emEviLptpmSZGQhLexMWlCuRdY1LoliSJUMUFUUkNXVkNXNUROUlpaRkVSRlBBSFc1WC4u",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const onClickHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.OPTION_MENU_TOGGLE });
  };

  const closeMenu = () => {
    closeMenus();
  };

  const onBlurHandler = (event) => {
    event.preventDefault();
    if (
      !state.mobileMenuOpen &&
      !event.currentTarget.contains(event.relatedTarget)
    ) {
      closeMenu();
    }
  };

  const chevronClass = state.optionMenuOpen
    ? styles.chevronFocused
    : styles.chevron;

  const rootButtonClass = state.optionMenuOpen
    ? styles.titleButtonMenuFocused
    : styles.titleButtonMenu;

  return (
    <li onBlur={onBlurHandler}>
      <button className={rootButtonClass} onClick={onClickHandler}>
        Options
        <img className={chevronClass} src={chevron} alt="" />
      </button>
      {state.optionMenuOpen && (
        <ul className={styles.subMenu1}>
          <li>
            <button
              className={styles.menuOptionButton}
              onClick={requestCrewHandler}
            >
              Request Crew
            </button>
          </li>
          <NavbarOptionTheme closeMenus={closeMenus} />
          <li>
            <button className={styles.menuOptionButton} onClick={logoutHandler}>
              Logout
            </button>
          </li>
        </ul>
      )}
    </li>
  );
};

export default WorkTypeMenu;
